module.exports = __webpack_public_path__ + "static/Logo-181a20c926d8176408078d8433e0a610.svg";